import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#DEBF7F'
        },
        secondary:{
            main: '#1A5597'
        }
    }
});

export default theme;